import { useGql } from '#imports'
import { getSdk as defaultGqlSdk } from '#gql/default'
export const GqlSdks = {
  default: defaultGqlSdk,
}
export const GqClientOps = {"default":["newsBanner","offerBanner","welcomeModal"]}
export const GqlNewsBanner = (...params) => useGql()('newsBanner', ...params)
export const GqlOfferBanner = (...params) => useGql()('offerBanner', ...params)
export const GqlWelcomeModal = (...params) => useGql()('welcomeModal', ...params)